/**
 * Reusable form field components
 */

export function Field({ label, error, required, children, hint }) {
  return (
    <div>
      {label && (
        <label className="label">
          {label}
          {required && <span className="text-red-500 ml-1">*</span>}
        </label>
      )}
      {children}
      {hint && !error && <p className="text-xs text-gray-400 mt-1">{hint}</p>}
      {error && <p className="text-xs text-red-500 mt-1">{error}</p>}
    </div>
  )
}

export function TextInput({ label, error, required, hint, ...props }) {
  return (
    <Field label={label} error={error} required={required} hint={hint}>
      <input
        className={`input ${error ? 'border-red-400 focus:ring-red-400' : ''}`}
        {...props}
      />
    </Field>
  )
}

export function SelectInput({ label, error, required, hint, options = [], placeholder, ...props }) {
  return (
    <Field label={label} error={error} required={required} hint={hint}>
      <select
        className={`input ${error ? 'border-red-400 focus:ring-red-400' : ''}`}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </Field>
  )
}

export function TextareaInput({ label, error, required, hint, rows = 3, ...props }) {
  return (
    <Field label={label} error={error} required={required} hint={hint}>
      <textarea
        rows={rows}
        className={`input resize-none ${error ? 'border-red-400 focus:ring-red-400' : ''}`}
        {...props}
      />
    </Field>
  )
}

export function CheckboxInput({ label, hint, ...props }) {
  return (
    <label className="flex items-center gap-3 cursor-pointer">
      <input
        type="checkbox"
        className="w-4 h-4 rounded border-gray-300 text-primary-600 focus:ring-primary-500"
        {...props}
      />
      <div>
        <span className="text-sm font-medium text-gray-700">{label}</span>
        {hint && <p className="text-xs text-gray-400">{hint}</p>}
      </div>
    </label>
  )
}

export function PhotoInput({ label, value, onChange, hint }) {
  return (
    <Field label={label} hint={hint}>
      <div className="flex items-center gap-4">
        {value && typeof value === 'string' ? (
          <img src={value} className="w-16 h-16 rounded-full object-cover border-2 border-gray-200" alt="" />
        ) : (
          <div className="w-16 h-16 rounded-full bg-gray-100 flex items-center justify-center text-gray-400 text-2xl">
            👤
          </div>
        )}
        <input
          type="file"
          accept="image/*"
          className="input flex-1"
          onChange={onChange}
        />
      </div>
    </Field>
  )
}

export function FormRow({ children, cols = 2 }) {
  return (
    <div className={`grid grid-cols-1 sm:grid-cols-${cols} gap-4`}>
      {children}
    </div>
  )
}
